export { default } from "bullitttime-embermodelsevent/models/jury-member";
